export default __webpack_public_path__ + "static/sr-katy-hero-ab621acf043629ca9d3ce7a9e57edb82.png";